import { History } from "lucide-react";
import { LineSheetsHeaderSection } from "../LineSheets";
import { useMemo } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { formatDiffDescription } from "./AuditTrail.utils";
import { getActiveAuditTrail, type LineItemDiff } from "@rebuild/shared";

export const AuditTrail = ({ auditTrail: _auditTrail }: { auditTrail: LineItemDiff[] }) => {
  const auditTrail = useMemo(() => {
    const auditTrail = structuredClone(_auditTrail);
    auditTrail.sort((diffA, diffB) => diffB.dateTime - diffA.dateTime);

    return getActiveAuditTrail(auditTrail);
  }, [_auditTrail]);

  if (!auditTrail.length) return null;

  return (
    <div className="flex flex-col space-y-2 pt-4">
      <LineSheetsHeaderSection title="Change Log">
        <History className="h-4 w-4" />
      </LineSheetsHeaderSection>

      <div className="px-4">
        <div className="border-border bg-muted/50 max-h-64 overflow-y-auto rounded-lg border">
          <Table className="[&_tr]:border-border/50">
            <TableHeader>
              <TableRow>
                <TableHead className="w-48 pr-4 font-semibold">Date</TableHead>
                <TableHead className="font-semibold">Change</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {auditTrail.map((diff) => (
                <TableRow key={JSON.stringify(diff)}>
                  <TableCell className="text-muted-foreground w-48 pr-4">{new Date(diff.dateTime).toLocaleString()}</TableCell>
                  <TableCell>{formatDiffDescription(diff)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};
